import {
    Box,
    Breadcrumbs,
    Button,
    Container,
    Divider,
    Input,
    InputAdornment,
    InputBase,
    Link,
    MenuItem,
    OutlinedInput,
    Pagination,
    Paper,
    Select,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    TextField,
    Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { TextFieldsOutlined } from "@mui/icons-material";
import { useLocation, useNavigate, useParams, useSearchParams, Link as RouterLink } from "react-router-dom";
import { useEffect } from "react";

const fakeDate = [
    "Montenegrin Mountain Hound",
    "Welsh Sheepdog",
    "American Foxhound",
    "Mahratta Greyhound",
    "East Siberian Laika",
    "Carea Castellano Manchego",
    "Denmark Feist",
    "Irish Red and White Setter",
    "Cirneco dell'Etna",
    "Rampur Greyhound",
];

function GroupDashboard() {
    // params
    const navigate = useNavigate();
    const [searchParams, setSeachParams] = useSearchParams();
    const groupType = searchParams.get("groupType") ?? "organization";
    const handleClickTab = (name) => setSeachParams({ groupType: name });
    const handleClickCreateNewGroup = () => navigate(`/admin/groups/new?groupType=${groupType}`);

    // fetch api
    const dataGroupList = fakeDate;

    console.log("reload");

    // store
    useEffect(() => {
        if (!searchParams.has("groupType") || !["organization", "team"].includes(groupType)) {
            setSeachParams({ groupType: groupType });
        }
    }, [groupType, searchParams, setSeachParams]);

    return (
        <>
            {/** Breadcrumbs */}
            <Container sx={{ marginY: 2 }}>
                <Breadcrumbs sx={{ my: 1 }}>
                    <div>Admin</div>
                    <div>Groups</div>
                </Breadcrumbs>
                <Divider />
            </Container>

            {/** Header */}
            <Container sx={{ marginY: 3 }}>
                <Box sx={{ display: "flex" }}>
                    <Box sx={{ flexGrow: 1 }}>
                        <Typography variant="h1" fontSize={34} fontWeight="bold">
                            Groups
                        </Typography>
                    </Box>
                    <Box>
                        <Button variant="contained" onClick={handleClickCreateNewGroup}>
                            New Group
                        </Button>
                    </Box>
                </Box>
            </Container>

            {/** Filder */}
            <Container sx={{ marginY: 3 }}>
                <Tabs value={groupType}>
                    <Tab value="organization" label="Organization (-)" onClick={() => handleClickTab("organization")} />
                    <Tab value="team" label="Team (-)" onClick={() => handleClickTab("team")} />
                </Tabs>

                <Divider />

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        flexWrap: "wrap",
                        gap: 1,
                        margin: 2,
                        marginBottom: 4,
                    }}
                >
                    <OutlinedInput
                        type="text"
                        variant="outlined"
                        size="small"
                        placeholder="Search by name"
                        startAdornment={
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        }
                        sx={{ flexGrow: 1 }}
                    />
                    <strong>Sort by</strong>
                    <Select variant="outlined" size="small" value="name">
                        <MenuItem value="name">Name</MenuItem>
                        <MenuItem value="createdAt desc">Last created</MenuItem>
                        <MenuItem value="createdAt asc">Oldest crated</MenuItem>
                    </Select>
                </Box>
            </Container>

            {/** Content */}
            <Container sx={{ marginY: 3 }}>
                {/** Table */}
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Parent</TableCell>
                                <TableCell>Children</TableCell>
                                <TableCell>Members</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {dataGroupList?.length > 0 ? (
                                dataGroupList?.map((group, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>
                                            <Link component={RouterLink} to={`/admin/groups/${index}`}>
                                                {group}
                                            </Link>
                                        </TableCell>
                                        <TableCell>??</TableCell>
                                        <TableCell>??</TableCell>
                                        <TableCell>{Math.round(Math.random() * 100)}</TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell>No Data</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>

                {/** Pagination */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: 3,
                    }}
                >
                    <Pagination count={999} />
                </Box>
            </Container>
        </>
    );
}

export default GroupDashboard;
